import { render, staticRenderFns } from "./MoveInAgeChart.vue?vue&type=template&id=4953799c&"
import script from "./MoveInAgeChart.vue?vue&type=script&lang=js&"
export * from "./MoveInAgeChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports